import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";

import { withRouter } from "react-router-dom";

import FileCard from "../common/FileCard";
import FlowModal from "../common/FlowModal";
import DiagramModal from "../common/DiagramModal";
import LabelModal from "../common/LabelModal";
import ToTop from "../common/ToTop";
import {
  getAllFileListZGFX,
  getAllLableList,
  collectFile,
  getUserInfo,
  addLabelToFile,
  cancelCollectFile,
  delelteFileLabel,
  addCollectLabel,
  getZgfxLableList,
} from "../../actions/subscribe";
import InfiniteScroll from "react-infinite-scroll-component";

import {
  getLabelId,
  getCollectId,
  getUserFileLabelList,
} from "../../utils/common";
import MuiAlert from "@mui/material/Alert";

import showSvg from "../../assets/svg/show.svg";

import store from "../../store";

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "110px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      marginTop: "12px",
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    listMessage: {
      paddingLeft: "30px",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {},
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      marginRight: "20px",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      width: "97px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "0 !important",
    },
    grayBtn: {
      width: "97px",
      height: "40px",
      marginLeft: "18px !important",
      background: "#fff !important",
      borderRadius: "2px !important",
      border: "1px solid #d9d9d9 !important",
      color: "#0F25D1 !important",
      boxShadow: "none !important",
    },
    container: {
      padding: "16px 18px 20px 0",
    },
    list: {
      paddingRight: "16px",
      width: "1px",
      "&.hide-time": {
        paddingLeft: "16px",
      },
    },
    label: {
      marginBottom: "16px",
    },
    labelContainer: {
      position: "sticky",
      top: "80px",
      minHeight: "400px",
      maxHeight: "calc(100vh - 140px)",
      padding: "20px 26px 20px 16px",
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0px 1px 10px 1px rgba(0, 0, 0, 0.05)",
      overflow: "auto",
    },
    labelTitle: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "10px",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
      "& img": {
        width: "21px",
        height: "21px",
        marginRight: "10px",
      },
      "& button": {
        marginLeft: "20px",
        width: "82px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "0",
        borderColor: "#D9D9D9",
        color: "#000",
        fontSize: "14px",
      },
    },
    showBtn: {
      width: "82px",
      height: "32px",
      padding: "0 !important",
      border: "1px solid #d9d9d9 !important",
      borderRadius: "2px",
      backgroundColor: "#fff !important",
      color: "rgba(0, 0, 0, .65) !important",
      fontSize: "14px",
      boxShadow: "none !important",
      "&.first": {
        marginRight: "10px",
      },
    },
    subTitle: {
      display: "flex",
      alignItems: "center",
      height: "22px",
      margin: "12px 0",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
      "& img": {
        marginRight: "3px",
        "&.hide": {
          transform: "rotate(-90deg)",
        },
      },
    },
    tag: {
      height: "22px",
      margin: "0 10px 16px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#0F25D1",
        borderColor: "#0F25D1",
      },
    },
    categoryLine: {
      height: "46px",
      padding: "0 7px",
      borderBottom: "1px dashed #d8d8d8",
      overflow: "hidden",
      "&.show": {
        height: "auto",
      },
    },
  };
};

class SearchFilePageZGFX extends Component {
  state = {
    searchType: "",
    keyword: "",
    baseKeyword: "",
    error: "",
    search_filters: {},
    page: 1,
    is_all: 0,
    count: 0,
    userId: "", //用户id
    username: "", //用户名
    dataId: "", //弹框数据id,点击右侧管理收藏按钮时，传空
    openMessage: "",
    errorMessage: "",
    // push: true,
    openModal: false,
    openDiagramModal: false,
    showTimeLine: true, // 是否展示时间线
    highText: false,
    modalTitle: "",
    fileList: [],
    labelList: [],
    labelArr: [],
    tagList: [],
    tagArr: [],
    collectFileId: [],
    collectLabelId: [],
    baseFileId: "", // 图谱根节点文件id
    showAll: false,
    hideSearchBtn: false, //隐藏智能搜索按钮
    flowModal: false, // 分类流程
    filterName: "", // 分类流程类型
    medical_file: "",
    company: "",
    fileType: "",
    // recommendList: [
    //   //推荐词
    //   {
    //     title: "常用标签",
    //     tagList: [
    //       {
    //         lable_content: "葡萄糖测试条",
    //         lable_id: "853",
    //       },
    //       {
    //         lable_content: "标签2",
    //         lable_id: "2",
    //       },
    //       {
    //         lable_content: "标签3",
    //         lable_id: "3",
    //       },
    //       {
    //         lable_content: "标签4",
    //         lable_id: "4",
    //       },
    //     ],
    //   },
    //   {
    //     title: "常用标签2",
    //     tagList: [
    //       {
    //         lable_content: "标签5",
    //         lable_id: "5",
    //       },
    //       {
    //         lable_content: "标签6",
    //         lable_id: "6",
    //       },
    //       {
    //         lable_content: "标签7",
    //         lable_id: "7",
    //       },
    //       {
    //         lable_content: "标签8",
    //         lable_id: "8",
    //       },
    //     ],
    //   },
    // ],
  };

  componentDidMount() {
    let pathname = this.props.location.pathname;
    let keyword = "";
    let company = "";
    let fileType = "";
    switch (pathname) {
      case "/recall":
        keyword = "召回产品";
        break;
      case "/gather":
        keyword = "跟踪汇总";
        break;
      case "/yrdCenter":
        keyword = "长三角";
        this.setState({ hideSearchBtn: true });
        break;
      case "/gbaCenter":
        keyword = "大湾区";
        this.setState({ hideSearchBtn: true });
        break;
      case "/medical":
        keyword = "博鳌";
        break;
      case "/market":
        company = "zgfx";
        fileType = "政府事务和市场准入";
        break;
      case "/law":
        company = "zgfx";
        fileType = "法规";
        break;
      case "/standard":
        company = "zgfx";
        fileType = "标准";
        break;
      case "/guidance":
        company = "zgfx";
        fileType = "指导原则";
        this.setState({ hideSearchBtn: true });
        break;
      default:
        break;
    }
    this.setState(
      {
        username: store.getState().auth.username,
        baseKeyword: keyword,
        company: company,
        fileType: fileType,
      },
      () => {
        this.queryUserInfo();
        this.loadMore();
      }
    );
    if (company == "zgfx") this.queryZgfxLable(fileType);
    else this.queryLable();
  }

  //查询用户信息;
  queryUserInfo = () => {
    getUserInfo({ username: this.state.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results[0];
        if (userData) {
          this.setState({
            userId: userData.id,
            collectFileId: userData.favorite_basefiles.map((v) => {
              return v.basefile_id;
            }),
            collectLabelId: userData.favorite_lables.map((v) => {
              return v.lable_id;
            }),
          });
        }
      }
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handlePreview = (url) => {
    const w = window.open("ablut:blank");
    localStorage.setItem("file_url", url);
    w.location.href = "/viewer";
  };

  queryLable = () => {
    const param = {
      lable_category_type: "高级筛选",
      is_shown: true,
    };
    getAllLableList(param).then((res) => {
      this.setState({
        labelList: res.results,
      });
    });
  };
  queryZgfxLable = (fileType) => {
    const param = {
      fileType: fileType,
    };
    getZgfxLableList(param).then((res) => {
      this.setState({
        labelList: res.results,
      });
    });
  };

  loadMore = (isInit) => {
    let keyword = [];
    if (this.state.keyword) {
      keyword.push(this.state.keyword);
    }
    if (this.state.baseKeyword) {
      keyword.push(this.state.baseKeyword);
    }
    const param = {
      search_filters: this.state.search_filters,
      keyword: keyword.join(),
      page: this.state.page,
      is_all: this.state.is_all,
      company: this.state.company,
      fileType: this.state.fileType,
      searchType: this.state.searchType,
    };
    getAllFileListZGFX(param).then((res) => {
      if (res && res.results) {
        let data = isInit
          ? [].concat(res.results)
          : this.state.fileList.concat(res.results);
        //时间轴
        let newFileList = data.map((v, i) => {
          if (i == 0) {
            v.showTime = true;
          } else {
            let prevTime = data[i - 1].medical_file_publish_date.substring(
              0,
              7
            );
            let nowTime = v.medical_file_publish_date.substring(0, 7);
            if (prevTime != nowTime) {
              v.showTime = true;
            }
          }
          return v;
        });
        this.setState({
          fileList: [].concat(newFileList),
          page: res.next ? this.state.page + 1 : 0,
          count: res.count,
        });
      }
    });
  };

  searchFile = () => {
    this.setState(
      {
        page: 1,
        is_all: 0,
        searchType: "",
        showTimeLine: true,
        highText: false,
      },
      () => this.loadMore(true)
    );
  };
  searchAllFile = () => {
    this.setState(
      {
        page: 1,
        is_all: 1,
        searchType: "",
        showTimeLine: true,
        highText: false,
      },
      () => this.loadMore(true)
    );
  };

  elasticSearch = () => {
    if (!this.state.keyword) {
      return;
    }
    this.setState(
      {
        page: 1,
        searchType: "es",
        showTimeLine: false,
        highText: true,
      },
      () => this.loadMore(true)
    );
  };

  // changePush = () => {
  //   this.setState({
  //     push: !this.state.push,
  //   });
  // };

  changeLabel = (label, category) => {
    let categoryName = category.lable_category_name;
    let labelName = label.lable_content;
    let labelId = label.lable_id;
    let search_filters = JSON.parse(JSON.stringify(this.state.search_filters));
    if (search_filters.hasOwnProperty(categoryName)) {
      let labelArr = search_filters[categoryName];
      let labelIndex = labelArr.findIndex((v) => {
        return v == labelName;
      });
      if (labelIndex > -1) {
        if (labelArr.length == 1) {
          delete search_filters[categoryName];
        } else {
          labelArr.splice(labelIndex, 1);
        }
      } else {
        labelArr.push(labelName);
      }
    } else {
      search_filters[categoryName] = [labelName];
    }

    let newArr = this.state.labelArr.concat([]);
    if (newArr.includes(labelId)) {
      newArr.splice(newArr.indexOf(labelId), 1);
    } else {
      newArr.push(labelId);
    }
    this.setState(
      {
        search_filters: search_filters,
        labelArr: newArr,
        page: 1,
      },
      () => this.loadMore(true)
    );
  };

  changeShow = (i) => {
    let show = this.state.labelList[i].showDetail;
    let newLabelList = [].concat(this.state.labelList);
    if (show) {
      newLabelList[i].showDetail = false;
    } else {
      newLabelList[i].showDetail = true;
    }
    let showAll = this.state.showAll;
    let size = newLabelList.filter((v) => {
      return v.showDetail;
    }).length;
    if (size == 0) {
      showAll = false;
    }
    if (size == newLabelList.length) {
      showAll = true;
    }
    this.setState({
      labelList: newLabelList,
      showAll: showAll,
    });
  };

  showAllDetail = () => {
    let newLabelList = [].concat(this.state.labelList);
    newLabelList.forEach((v) => {
      v.showDetail = !this.state.showAll;
    });
    this.setState({
      labelList: newLabelList,
      showAll: !this.state.showAll,
    });
  };

  clearAllFilter = () => {
    this.setState(
      {
        search_filters: {},
        labelArr: [],
        page: 1,
      },
      () => this.loadMore(true)
    );
  };

  handleClose = () => {
    this.setState({
      openModal: false,
    });
    this.queryUserInfo();
  };

  //收藏文件
  handAdd = (tag) => {
    //检查是否已存在
    let index = this.state.tagArr.findIndex((v) => {
      return v.lable_content == tag;
    });
    if (index > -1) {
      this.setState({
        openMessage: true,
        errorMessage: "该标签已存在",
      });
      setTimeout(() => {
        this.closeMessage();
      }, 3000);
      return;
    }
    //获取标签id
    getLabelId(tag, this.state.userId).then((labelId) => {
      //打标签
      addLabelToFile({
        base_file: this.state.dataId,
        lable: labelId,
        lable_update_user: this.state.userId,
      }).then((resp) => {
        if (resp.id) {
          this.setState({
            tagArr: this.state.tagArr.concat([
              {
                lable_content: tag,
                lable_id: labelId,
              },
            ]),
          });
        }
      });

      //收藏标签
      if (this.state.collectLabelId.includes(labelId) == false) {
        addCollectLabel({
          lable: labelId,
          user: this.state.userId,
        });
      }
    });
  };

  handRemove = (id) => {
    // getFileLabelId(this.state.dataId, id, this.state.userId).then(fileLabelId => {
    delelteFileLabel(id);
    // })
    let tagArr = [].concat(this.state.tagArr);
    let index = tagArr.findIndex((v) => {
      return v.lable_id === id;
    });
    tagArr.splice(index, 1);
    this.setState({
      tagArr: [].concat(tagArr),
    });
  };
  //收藏文件
  handCollect = (id) => {
    this.setState({
      openModal: true,
      modalTitle: "文件收藏",
      dataId: id,
      tagArr: [],
    });
    //收藏文件
    collectFile({
      base_file: id,
      user: this.state.userId,
    });
  };
  //取消收藏
  handCancelCollect = (id) => {
    getCollectId(id, this.state.userId).then((collectId) => {
      cancelCollectFile(collectId).then(() => {
        this.queryUserInfo();
      });
    });
  };
  //管理标签
  handSetting = (id) => {
    getUserFileLabelList(id, this.state.userId).then((list) => {
      this.setState({
        openModal: true,
        dataId: id,
        modalTitle: "管理标签",
        tagArr: list,
      });
    });
  };
  // 分类流程
  handFlow = (data) => {
    this.setState({
      flowModal: true,
      medical_file: data,
      filterName: data.base_file.file_category,
    });
  };
  closeFlow = () => {
    this.setState({
      flowModal: false,
    });
  };
  //图谱
  handleDiagram = (id) => {
    this.setState({
      openDiagramModal: true,
      baseFileId: id,
    });
  };
  //关闭弹框
  handleClose = () => {
    this.setState({
      openModal: false,
      openDiagramModal: false,
    });
    this.queryUserInfo();
  };

  //关闭消息弹框
  closeMessage = () => {
    this.setState({
      openMessage: false,
    });
  };

  //回车事件
  onKeyDownchange = (e) => {
    if (e.keyCode == 13) {
      this.searchFile();
    }
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className={classes.root}>
        <Grid container className={classes.search}>
          <Grid item className={classes.inputGroup}>
            <TextField
              error={this.state.error}
              label="关键词搜索"
              placeholder="多个关键词用逗号隔开"
              value={this.state.keyword}
              helperText={this.state.error}
              variant="outlined"
              name="keyword"
              onKeyDown={(e) => this.onKeyDownchange(e)}
              onChange={this.onChange}
              className={classes.input}
              size="small"
            />
            <Button
              onClick={this.searchFile}
              className={classes.btn}
              variant="contained"
              title="对文件信息及文件名进行准确检索"
            >
              精确搜索
            </Button>

            {!this.state.hideSearchBtn && (
              <Button
                onClick={this.elasticSearch}
                className={classes.grayBtn}
                variant="contained"
                title="对文件信息以及文件名进行模糊匹配，搜索结果按匹配度从高到低排序"
              >
                智能搜索
              </Button>
            )}

            <Button
              onClick={this.searchAllFile}
              className={classes.grayBtn}
              variant="contained"
              title="对全文内容进行检索，搜索结果按时间线排序"
            >
              全文搜索
            </Button>
          </Grid>

          <Grid item className={classes.result}>
            <Typography className={classes.line}>
              一共有搜索到
              <span className={classes.total}>{this.state.count}</span>
              个结果
            </Typography>
          </Grid>
        </Grid>

        <Grid container className={classes.container}>
          <Grid
            item
            xs={7}
            className={[
              classes.list,
              this.state.showTimeLine ? "" : "hide-time",
            ].join(" ")}
          >
            <InfiniteScroll
              dataLength={this.state.fileList.length}
              next={this.loadMore}
              hasMore={this.state.page == 0 ? false : true}
              loader={<h4 className={classes.listMessage}>Loading...</h4>}
              endMessage={
                <h4 className={classes.listMessage}>
                  {this.state.fileList.length
                    ? "没有了"
                    : "没有找到您想要的内容，请更换关键词或者尝试使用空格分隔关键词"}
                </h4>
              }
            >
              {this.state.fileList.map((item, i) => {
                return (
                  <FileCard
                    showSetting={this.state.collectFileId.includes(
                      item.base_file.file_id
                    )}
                    collect={this.state.collectFileId.includes(
                      item.base_file.file_id
                    )}
                    showTimeLine={this.state.showTimeLine}
                    showFlow={true}
                    clearTop={i === 0}
                    key={item.base_file.file_id}
                    highText={this.state.highText}
                    keyword={this.state.keyword}
                    medical_file={item}
                    handlePreview={this.handlePreview}
                    handCollect={this.handCollect}
                    handleDiagram={this.handleDiagram}
                    handCancelCollect={this.handCancelCollect}
                    handSetting={this.handSetting}
                    handFlow={this.handFlow}
                  />
                );
              })}
            </InfiniteScroll>
          </Grid>
          <Grid item xs={5} className={classes.label}>
            <div className={classes.labelContainer}>
              <div className={classes.labelTitle}>
                <div className={classes.titleLeft}>
                  <img src="../static/images/subscribe-title.png" alt="" />
                  高级筛选
                </div>
                <div>
                  <Button
                    onClick={this.clearAllFilter}
                    className={[classes.showBtn, "first"].join(" ")}
                    variant="contained"
                  >
                    清空筛选
                  </Button>
                  <Button
                    onClick={this.showAllDetail}
                    className={classes.showBtn}
                    variant="contained"
                  >
                    {this.state.showAll ? "全部折叠" : "全部展开"}
                  </Button>
                </div>
              </div>
              {this.state.labelList.map((item, i) => {
                return (
                  <div
                    key={item.lable_category_name}
                    className={[
                      classes.categoryLine,
                      item.showDetail ? "show" : "",
                    ].join(" ")}
                  >
                    <Typography
                      className={classes.subTitle}
                      onClick={() => this.changeShow(i)}
                    >
                      <img
                        className={item.showDetail ? "show" : "hide"}
                        src={showSvg}
                      />
                      {item.lable_category_name}
                    </Typography>
                    {item.lables.map((label) => {
                      return (
                        <span
                          key={label.lable_content}
                          onClick={() => this.changeLabel(label, item)}
                          className={[
                            classes.tag,
                            this.state.labelArr.includes(label.lable_id)
                              ? "active"
                              : "",
                          ].join(" ")}
                        >
                          {label.lable_content}
                        </span>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </Grid>
        </Grid>

        <ToTop />

        <Modal
          open={this.state.openModal}
          onClose={this.handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <LabelModal
              width={520}
              title={this.state.modalTitle}
              close={this.handleClose}
              tagArr={this.state.tagArr}
              handAdd={this.handAdd}
              handRemove={this.handRemove}
              dataId={this.state.dataId}
              // recommendList={this.state.recommendList}
            />
          </div>
        </Modal>

        <Modal
          open={this.state.flowModal}
          onClose={this.closeFlow}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <FlowModal
              medical_file={this.state.medical_file}
              filterName={this.state.filterName}
              close={this.closeFlow}
            />
          </div>
        </Modal>
        <Modal
          open={this.state.openDiagramModal}
          onClose={this.handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <DiagramModal fileId={this.state.baseFileId} />
          </div>
        </Modal>

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.openMessage}
          onClose={this.closeMessage}
        >
          <MuiAlert elevation={6} variant="filled" severity="warning">
            {this.state.errorMessage}
          </MuiAlert>
        </Snackbar>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(SearchFilePageZGFX));
